import { KPIIndicator, ChartConfig } from '../types';

export const kpiData: KPIIndicator[] = [
  // Acquisition
  {
    id: 'ip-distribution',
    title: '访问IP的国家/地区分布热图',
    description: '通过分析用户访问IP的地理位置分布，了解用户来源地区的分布情况，为市场拓展和本地化策略提供数据支持。',
    category: 'acquisition',
    subcategory: '用户获取分析',
    data: [
      { label: '主要地区', value: '亚太地区' },
      { label: '覆盖率', value: '85.2%', trend: 'up' }
    ],
    hasChart: true,
    chartType: 'doughnut'
  },
  {
    id: 'kyc-submission',
    title: 'KYC提交率',
    description: 'KYC（了解你的客户）提交率反映了用户完成身份验证的积极性，是衡量用户质量和合规性的重要指标。',
    category: 'acquisition',
    subcategory: '用户获取分析',
    data: [
      { label: '提交率', value: '78.5%', trend: 'up' },
      { label: '目标', value: '85%' }
    ],
    hasChart: false
  },
  {
    id: 'kyc-approval',
    title: 'KYC审核通过率',
    description: 'KYC审核通过率反映了用户提供信息的准确性和完整性，是衡量用户质量的重要指标。',
    category: 'acquisition',
    subcategory: '用户获取分析',
    data: [
      { label: '通过率', value: '92.3%', trend: 'up' },
      { label: '平均审核时间', value: '2.1天' }
    ],
    hasChart: false
  },
  {
    id: 'gender-ratio',
    title: '性别比例',
    description: '分析用户性别分布，了解平台用户群体的性别特征。',
    category: 'acquisition',
    subcategory: '用户获取分析',
    data: [
      { label: '男性', value: '68.5%' },
      { label: '女性', value: '31.5%' }
    ],
    hasChart: true,
    chartType: 'pie'
  },
  {
    id: 'geographic-distribution',
    title: '地域分布',
    description: '分析用户的地域分布情况，了解不同地区的用户特征和需求。',
    category: 'acquisition',
    subcategory: '用户获取分析',
    data: [
      { label: '一线城市', value: '42.3%' },
      { label: '二线城市', value: '35.7%' }
    ],
    hasChart: true,
    chartType: 'bar'
  },

  // Activation - First Deposit
  {
    id: 'registration-to-deposit',
    title: '注册到首存转化率（14/30天后）',
    description: '衡量从用户注册到完成首次存款的转化效果，是评估用户激活质量的关键指标。',
    category: 'activation',
    subcategory: '首次存款指标',
    data: [
      { label: '14天转化率', value: '23.5%', trend: 'up' },
      { label: '30天转化率', value: '31.2%', trend: 'up' }
    ],
    hasChart: false
  },
  {
    id: 'average-first-deposit',
    title: '平均首存金额',
    description: '分析用户首次存款的平均金额，了解用户的投资能力和风险偏好。',
    category: 'activation',
    subcategory: '首次存款指标',
    data: [
      { label: '平均金额', value: '$2,450' },
      { label: '中位数', value: '$1,200' }
    ],
    hasChart: false
  },
  {
    id: 'deposit-asset-preference',
    title: '首存资产类别偏好',
    description: '分析用户在首次存款时选择的资产类别，了解用户对不同加密货币的偏好。',
    category: 'activation',
    subcategory: '首次存款指标',
    data: [
      { label: 'USDT', value: '45.2%' },
      { label: 'USDC', value: '28.7%' }
    ],
    hasChart: true,
    chartType: 'pie'
  },
  {
    id: 'deposit-time-distribution',
    title: '首存完成时间分布',
    description: '分析用户完成首次存款的时间分布，了解用户的存款行为模式。',
    category: 'activation',
    subcategory: '首次存款指标',
    data: [
      { label: '工作日', value: '65.3%' },
      { label: '周末', value: '34.7%' }
    ],
    hasChart: true,
    chartType: 'multiple'
  },

  // Activation - First Trade
  {
    id: 'deposit-to-trade-conversion',
    title: '首存到首交易转化率',
    description: '衡量从首次存款到首次交易的转化效果，是评估用户激活质量的重要指标。',
    category: 'activation',
    subcategory: '首次交易激活',
    data: [
      { label: '转化率', value: '67.8%', trend: 'up' },
      { label: '目标', value: '75%' }
    ],
    hasChart: false
  },
  {
    id: 'first-trade-interval',
    title: '首次交易时间间隔',
    description: '分析用户从存款到首次交易的时间间隔，了解用户的交易行为模式。',
    category: 'activation',
    subcategory: '首次交易激活',
    data: [
      { label: '平均间隔', value: '3.2小时' },
      { label: '中位数', value: '1.5小时' }
    ],
    hasChart: false
  },
  {
    id: 'first-trade-amount',
    title: '首笔交易金额',
    description: '分析用户首次交易的金额分布，了解用户的交易规模和风险偏好。',
    category: 'activation',
    subcategory: '首次交易激活',
    data: [
      { label: '平均金额', value: '$850' },
      { label: '中位数', value: '$420' }
    ],
    hasChart: false
  },
  {
    id: 'first-trade-category',
    title: '首笔交易品类',
    description: '分析用户首次交易的资产类别，了解用户对不同交易品种的偏好。',
    category: 'activation',
    subcategory: '首次交易激活',
    data: [
      { label: 'EURUSD', value: '15.2%' },
      { label: 'BTCUSD', value: '12.8%' }
    ],
    hasChart: true,
    chartType: 'bar'
  },
  {
    id: 'first-day-trade-frequency',
    title: '首日交易频次',
    description: '分析用户在首次交易当天的交易频次，了解用户的交易活跃度。',
    category: 'activation',
    subcategory: '首次交易激活',
    data: [
      { label: '平均频次', value: '2.8次' },
      { label: '中位数', value: '2次' }
    ],
    hasChart: false
  },

  // Retention - Customer Activity
  {
    id: 'trade-frequency',
    title: '交易频率',
    description: '分析用户的交易频率，了解用户的交易活跃度和平台粘性。',
    category: 'retention',
    subcategory: '客户活跃度',
    data: [
      { label: '日均交易', value: '1.2次' },
      { label: '周均交易', value: '8.5次' }
    ],
    hasChart: false
  },
  {
    id: 'flash-exchange-frequency',
    title: '闪兑频率',
    description: '分析用户使用闪兑功能的频率，了解用户对快速交易的需求。',
    category: 'retention',
    subcategory: '客户活跃度',
    data: [
      { label: '日均闪兑', value: '0.8次' },
      { label: '占比', value: '35.2%' }
    ],
    hasChart: false
  },

  // Retention - Capital Flow
  {
    id: 'customer-net-inflow',
    title: '客户净流入金额',
    description: '分析客户的资金净流入情况，了解平台的资金吸引力。',
    category: 'retention',
    subcategory: '资金流动指标',
    data: [
      { label: '日均净流入', value: '$125K', trend: 'up' },
      { label: '月均净流入', value: '$3.8M', trend: 'up' }
    ],
    hasChart: false
  },
  {
    id: 'asset-category-inflow',
    title: '资产类别净流入',
    description: '分析不同资产类别的净流入情况，了解用户对不同加密货币的偏好。',
    category: 'retention',
    subcategory: '资金流动指标',
    data: [
      { label: 'USDT', value: '+$85K', trend: 'up' },
      { label: 'BTC', value: '+$32K', trend: 'up' }
    ],
    hasChart: false
  },
  {
    id: 'deposit-frequency',
    title: '存款频率',
    description: '分析用户的存款频率，了解用户的资金投入行为。',
    category: 'retention',
    subcategory: '资金流动指标',
    data: [
      { label: '月均存款', value: '2.3次' },
      { label: '活跃用户', value: '78.5%' }
    ],
    hasChart: false
  },
  {
    id: 'deposit-amount-trend',
    title: '存款金额趋势',
    description: '分析用户存款金额的变化趋势，了解用户的投资行为变化。',
    category: 'retention',
    subcategory: '资金流动指标',
    data: [
      { label: '月环比', value: '+12.5%', trend: 'up' },
      { label: '年同比', value: '+28.3%', trend: 'up' }
    ],
    hasChart: false
  },
  {
    id: 'capital-retention-cycle',
    title: '资金留存周期',
    description: '分析用户资金在平台的留存时间，了解用户的投资周期。',
    category: 'retention',
    subcategory: '资金流动指标',
    data: [
      { label: '平均周期', value: '45天' },
      { label: '中位数', value: '32天' }
    ],
    hasChart: false
  },

  // Retention - Withdrawal Behavior
  {
    id: 'withdrawal-efficiency',
    title: '提取效率',
    description: '分析用户提取资金的效率，了解平台的提现服务质量。',
    category: 'retention',
    subcategory: '提取行为分析',
    data: [
      { label: '平均时间', value: '2.5小时' },
      { label: '目标时间', value: '2小时' }
    ],
    hasChart: false
  },
  {
    id: 'withdrawal-success-rate',
    title: '提取成功率',
    description: '分析用户提取操作的成功率，了解平台的提现服务质量。',
    category: 'retention',
    subcategory: '提取行为分析',
    data: [
      { label: '成功率', value: '98.7%', trend: 'up' },
      { label: '目标', value: '99%' }
    ],
    hasChart: true,
    chartType: 'pie'
  },
  {
    id: 'withdrawal-redeposit-rate',
    title: '提取后回存率',
    description: '分析用户提取后重新存款的比例，了解用户的忠诚度。',
    category: 'retention',
    subcategory: '提取行为分析',
    data: [
      { label: '回存率', value: '65.3%', trend: 'up' },
      { label: '平均时间', value: '15天' }
    ],
    hasChart: true,
    chartType: 'pie'
  },

  // Revenue - Revenue Metrics
  {
    id: 'daily-weekly-monthly-revenue',
    title: '日/周/月平均每月产生的收入',
    description: '分析平台在不同时间维度的收入表现，了解收入的时间分布特征。',
    category: 'revenue',
    subcategory: '收入指标',
    data: [
      { label: '日均收入', value: '$45K', trend: 'up' },
      { label: '月均收入', value: '$1.35M', trend: 'up' }
    ],
    hasChart: false
  },
  {
    id: 'customer-lifetime-value',
    title: '客户在整个生命周期内的预期净收益',
    description: '分析客户在整个生命周期内的预期净收益，了解客户价值。',
    category: 'revenue',
    subcategory: '收入指标',
    data: [
      { label: '平均LTV', value: '$2,850' },
      { label: '中位数', value: '$1,200' }
    ],
    hasChart: false
  },
  {
    id: 'customer-acquisition-payback',
    title: '回收或减去新客户的平均时间',
    description: '分析平台回收新客户获取成本的平均时间，了解客户价值实现周期。',
    category: 'revenue',
    subcategory: '收入指标',
    data: [
      { label: '平均时间', value: '8.5个月' },
      { label: '目标', value: '6个月' }
    ],
    hasChart: false
  },
  {
    id: 'profitable-customers-percentage',
    title: '%的客户在盈利',
    description: '分析盈利客户的比例，了解平台的整体盈利能力。',
    category: 'revenue',
    subcategory: '收入指标',
    data: [
      { label: '盈利客户', value: '72.5%', trend: 'up' },
      { label: '目标', value: '75%' }
    ],
    hasChart: true,
    chartType: 'pie'
  },
  {
    id: 'profitable-trades-percentage',
    title: '%的交易在盈利',
    description: '分析盈利交易的比例，了解交易的整体盈利能力。',
    category: 'revenue',
    subcategory: '收入指标',
    data: [
      { label: '盈利交易', value: '68.3%', trend: 'up' },
      { label: '目标', value: '70%' }
    ],
    hasChart: true,
    chartType: 'pie'
  },

  // Revenue - Revenue Sources
  {
    id: 'spread-revenue',
    title: '通过买卖价格产生的收入',
    description: '分析通过买卖价差产生的收入，了解交易收入的主要来源。',
    category: 'revenue',
    subcategory: '收入来源分析',
    data: [
      { label: '日均收入', value: '$28K', trend: 'up' },
      { label: '占比', value: '62.2%' }
    ],
    hasChart: false
  },
  {
    id: 'commission-revenue',
    title: '交易产生的佣金和手续费收入',
    description: '分析通过交易佣金和手续费产生的收入，了解服务费收入情况。',
    category: 'revenue',
    subcategory: '收入来源分析',
    data: [
      { label: '日均收入', value: '$12K', trend: 'up' },
      { label: '占比', value: '26.7%' }
    ],
    hasChart: false
  },
  {
    id: 'overnight-fee-revenue',
    title: '隔夜待合费用产生的收入',
    description: '分析通过隔夜费用产生的收入，了解资金占用费收入情况。',
    category: 'revenue',
    subcategory: '收入来源分析',
    data: [
      { label: '日均收入', value: '$5K', trend: 'up' },
      { label: '占比', value: '11.1%' }
    ],
    hasChart: false
  },
  {
    id: 'product-category-contribution',
    title: '不同产品类别的收益贡献率',
    description: '分析不同产品类别的收益贡献，了解各产品的盈利能力。',
    category: 'revenue',
    subcategory: '收入来源分析',
    data: [
      { label: '现货交易', value: '58.3%' },
      { label: '合约交易', value: '41.7%' }
    ],
    hasChart: false
  },
  {
    id: 'platform-customer-profit-ratio',
    title: '平台与客户交易盈亏的比值',
    description: '分析平台与客户在交易中的盈亏比例，了解风险控制效果。',
    category: 'revenue',
    subcategory: '收入来源分析',
    data: [
      { label: '平台盈利', value: '65.2%', trend: 'up' },
      { label: '客户盈利', value: '34.8%' }
    ],
    hasChart: true,
    chartType: 'pie'
  },
  {
    id: 'revenue-growth-rate',
    title: '环比/同比收入增长率',
    description: '分析收入的环比和同比增长率，了解收入增长趋势。',
    category: 'revenue',
    subcategory: '收入来源分析',
    data: [
      { label: '环比增长', value: '+8.5%', trend: 'up' },
      { label: '同比增长', value: '+32.7%', trend: 'up' }
    ],
    hasChart: false
  },
  {
    id: 'ai-operations-analysis',
    title: 'AI运营分析',
    description: '基于AI算法分析运营数据，提供智能化的运营建议和预测分析。',
    category: 'ai-analytics',
    subcategory: 'AI运营分析',
    data: [

    ],
    hasChart: false
  },
  {
    id: 'ai-chat-assistant',
    title: 'AI智能对话',
    description: '与 MC Markets AI 助手进行实时对话，获取数据分析、业务建议和市场洞察。',
    category: 'ai-analytics',
    subcategory: 'AI运营分析',
    data: [
    ],
    hasChart: false
  }
];

export const chartConfigs: Record<string, ChartConfig[]> = {
  'ip-distribution': [{
    type: 'doughnut',
    data: {
      labels: ['中国', '美国', '日本', '韩国', '新加坡', '其他'],
      datasets: [{
        data: [35, 25, 15, 12, 8, 5],
        backgroundColor: [
          '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#6b7280'
        ],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#1f2937',
            font: { size: 12 }
          }
        }
      }
    }
  }],
  'deposit-asset-preference': [{
    type: 'pie',
    data: {
      labels: ['USDC', 'SOL', 'ETH', 'USDT', 'WBTC'],
      datasets: [{
        data: [28.7, 15.3, 22.1, 25.2, 8.7],
        backgroundColor: [
          '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'
        ],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#1f2937',
            font: { size: 12 }
          }
        }
      }
    }
  }],
  'gender-ratio': [{
    type: 'pie',
    data: {
      labels: ['男性', '女性'],
      datasets: [{
        data: [68.5, 31.5],
        backgroundColor: ['#3b82f6', '#10b981'],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#1f2937',
            font: { size: 12 }
          }
        }
      }
    }
  }],
  'geographic-distribution': [{
    type: 'bar',
    data: {
      labels: ['一线城市', '二线城市', '三线城市', '其他'],
      datasets: [{
        label: '用户分布',
        data: [42.3, 35.7, 15.2, 6.8],
        backgroundColor: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444'],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false }
      },
      scales: {
        y: {
          beginAtZero: true,
          grid: { color: '#e5e7eb' },
          ticks: { color: '#6b7280' }
        },
        x: {
          grid: { display: false },
          ticks: { color: '#6b7280' }
        }
      }
    }
  }],
  'profitable-customers-percentage': [{
    type: 'pie',
    data: {
      labels: ['盈利客户', '亏损客户'],
      datasets: [{
        data: [72.5, 27.5],
        backgroundColor: ['#10b981', '#ef4444'],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#1f2937',
            font: { size: 12 }
          }
        }
      }
    }
  }],
  'profitable-trades-percentage': [{
    type: 'pie',
    data: {
      labels: ['盈利交易', '亏损交易'],
      datasets: [{
        data: [68.3, 31.7],
        backgroundColor: ['#10b981', '#ef4444'],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#1f2937',
            font: { size: 12 }
          }
        }
      }
    }
  }],
  'withdrawal-success-rate': [{
    type: 'pie',
    data: {
      labels: ['成功提取', '提取失败'],
      datasets: [{
        data: [98.7, 1.3],
        backgroundColor: ['#10b981', '#ef4444'],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#1f2937',
            font: { size: 12 }
          }
        }
      }
    }
  }],
  'withdrawal-redeposit-rate': [{
    type: 'pie',
    data: {
      labels: ['重新存款', '未重新存款'],
      datasets: [{
        data: [65.3, 34.7],
        backgroundColor: ['#3b82f6', '#6b7280'],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#1f2937',
            font: { size: 12 }
          }
        }
      }
    }
  }],
  'platform-customer-profit-ratio': [{
    type: 'pie',
    data: {
      labels: ['平台盈利', '客户盈利'],
      datasets: [{
        data: [65.2, 34.8],
        backgroundColor: ['#10b981', '#3b82f6'],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#1f2937',
            font: { size: 12 }
          }
        }
      }
    }
  }],
  'deposit-time-distribution': [
    {
      type: 'pie',
      data: {
        labels: ['工作日', '周末'],
        datasets: [{
          data: [653, 347],
          backgroundColor: ['#3b82f6', '#10b981'],
          borderWidth: 0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              color: '#1f2937',
              font: { size: 12 }
            }
          }
        }
      }
    },
    {
      type: 'line',
      data: {
        labels: ['凌晨(0-6)', '上午(6-12)', '下午(12-18)', '晚上(18-24)'],
        datasets: [{
          label: '首存完成数量',
          data: [85, 245, 312, 358],
          borderColor: '#000000',
          backgroundColor: ['rgba(59, 130, 246, 0.1)'],
          borderWidth: 3,
          fill: true
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: { color: '#e5e7eb' },
            ticks: { color: '#6b7280' }
          },
          x: {
            grid: { display: false },
            ticks: { color: '#6b7280' }
          }
        }
      }
    },
    {
      type: 'bar',
      data: {
        labels: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        datasets: [{
          label: '首存完成数量',
          data: [145, 167, 189, 178, 156, 134, 123],
          backgroundColor: [
            '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#84cc16'
          ],
          borderWidth: 0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false }
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: { color: '#e5e7eb' },
            ticks: { color: '#6b7280' }
          },
          x: {
            grid: { display: false },
            ticks: { color: '#6b7280' }
          }
        }
      }
    }
  ],
  'first-trade-category': [{
    type: 'bar',
    data: {
      labels: [
        'EURUSD', 'GBPUSD', 'USDJPY', 'USDCHF', 'USDCAD', 'AUDUSD', 'NZDUSD',
        'XAUUSD', 'XAGUSD', 'NAS100', 'US500', 'US30', 'UK100', 'GER30', 'JPN225',
        'HK50', 'USOIL', 'XNGUSD', 'BTCUSD', 'ETHUSD', 'SOLUSD', 'TSLA', 'NVDA',
        'MSFT', 'AAPL', 'AMZN', 'META', 'GOOGL', 'MSTR'
      ],
      datasets: [{
        label: '首笔交易占比',
        data: [
          15.2, 12.8, 8.5, 6.2, 5.8, 4.9, 3.7,  // 外汇
          7.3, 4.1, 6.8, 5.4, 4.2, 3.9, 3.1, 2.8, 2.5,  // 指数
          3.2, 2.1, 8.9, 6.7, 4.3,  // 商品
          12.5, 9.8, 7.2, 5.6, 4.8, 3.9, 3.4, 2.9, 2.1  // 加密货币和股票
        ],
        backgroundColor: [
          // 外汇 - 蓝色系
          '#3b82f6', '#1d4ed8', '#1e40af', '#1e3a8a', '#3730a3', '#5b21b6', '#7c3aed',
          // 指数 - 绿色系
          '#10b981', '#059669', '#047857', '#065f46', '#064e3b', '#14532d', '#166534',
          // 商品 - 橙色系
          '#f59e0b', '#d97706', '#b45309',
          // 加密货币和股票 - 红色系
          '#ef4444', '#dc2626', '#b91c1c', '#991b1b', '#7f1d1d', '#dc2626', '#b91c1c', '#991b1b', '#7f1d1d'
        ],
        borderWidth: 0
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: function(context: any) {
              return `${context.label}: ${context.parsed.y}%`;
            }
          }
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          max: 20,
          grid: { color: '#e5e7eb' },
          ticks: { 
            color: '#6b7280',
            callback: function(value: any) {
              return value + '%';
            }
          }
        },
        x: {
          grid: { display: false },
          ticks: { 
            color: '#6b7280',
            maxRotation: 45,
            minRotation: 45,
            fontSize: 10
          }
        }
      }
    }
  }],
  
  // AI Analytics - 移除图表配置，使用 bullet point 展示
}; 